import { render, staticRenderFns } from "./NICUInvoice.vue?vue&type=template&id=c85fa8ae"
import script from "./NICUInvoice.vue?vue&type=script&lang=js"
export * from "./NICUInvoice.vue?vue&type=script&lang=js"
import style0 from "./NICUInvoice.vue?vue&type=style&index=0&id=c85fa8ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports